import type { ReactNode } from 'react'
import { TableDefaultsProvider } from '@shared/components/ui/data-table'
import { PageLoader } from '@shared/components/ui/page-loader'
import { useCurrentUser } from '@modules/auth'
import { useAccountPreferences } from '../hooks/useSettings'

/**
 * Bọc nội dung trang trong MainLayout: chờ tùy chọn tài khoản tải xong rồi mới vẽ, để bảng khởi tạo đúng mật độ /
 * số dòng (useState chỉ đọc mặc định một lần). Tải lỗi hoặc nhân viên Finiva → chạy với mặc định hệ thống.
 */
export function PreferencesGate({ children }: { children: ReactNode }) {
  const { user } = useCurrentUser()
  // finiva: nhân viên Finiva (không thuộc tập đoàn) không có tùy chọn – admin chỉ có nhân viên Finiva nên luôn tải
  const { data, isLoading } = useAccountPreferences(!!user)
  if (isLoading) return <PageLoader />
  return (
    <TableDefaultsProvider
      value={{ density: data?.density ?? null, pageSize: data?.pageSize ?? null }}
    >
      {children}
    </TableDefaultsProvider>
  )
}
